<template>
  <v-card outlined tile width="100%">
    <v-toolbar flat color="bgColor">
      <v-layout justify-center>
        <v-toolbar-title class="primary--text">
          {{ date | date }}
        </v-toolbar-title>
      </v-layout>
    </v-toolbar>
    <v-card-text ref="times" class="times">
      <div class="wrap">
        <v-layout v-for="time in times" :key="time.timeStr" justify-center>
          <v-checkbox
            :input-value="value"
            :value="`${date} ${time.timeStr}`"
            hide-details
            color="primary"
            on-icon="mdi-radiobox-marked"
            off-icon="mdi-radiobox-blank"
            @change="$emit('input', $event)"
          >
            <span slot="label">
              {{ time.timeStr }}
            </span>
          </v-checkbox>
        </v-layout>
      </div>
      <v-layout v-if="loaded && times.length === 0" justify-center>
        予約できません。
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  filters: {
    date(value) {
      return moment(value).format('M/D（ddd）')
    },
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    shopId: {
      type: String,
      required: true,
    },
    menuId: {
      type: [Number, String],
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    times: [],
    loaded: false,
  }),
  created() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      this.times = await this.$api
        .shops(this.shopId)
        .menus(this.menuId)
        .reservableTimes(this.date)
        .get()
      this.loaded = true
      // NOTE: 午前中に予約を集めないために初期表示で200pxスクロールした状態にする
      this.$nextTick(() => {
        //this.$refs.times.scrollTop = 220
        this.$refs.times.scrollTo({
          top: 210,
          behavior: 'smooth',
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.times {
  position: relative;
  overflow-y: auto;
  height: calc(100% - 56px - 7px);
  // height: 100%;
}
.wrap {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
